import React, { useEffect, useState } from "react";
import "./Home.css";
import "./Hero.css";
import "./Hero.mobile.css";
import "./Beneficios.css";
import "./Clientes.css";

import LogoZoco from "../../assets/img/Contactanos/Logo-Zoco.png";
import Terminal from "../../assets/img/Contactanos/square-terminal.png";

// 👇 tus imágenes de beneficios
import preciso from "../../assets/img/Contactanos/preciso.png";
import sinGastos from "../../assets/img/Contactanos/sin-gastos.png";
import atencionHumana from "../../assets/img/Contactanos/atencion-humana.png";
import menorCosto from "../../assets/img/Contactanos/el-menor-costo.png";

// 👇 tus imágenes de clientes
import cliente1 from "../../assets/img/Contactanos/los-electricos.png";
import cliente2 from "../../assets/img/Contactanos/mr-johns.png";
import cliente3 from "../../assets/img/Contactanos/Toyotero.png";
import cliente4 from "../../assets/img/Contactanos/24-street.png";
import cliente5 from "../../assets/img/Contactanos/llamame-lola.png";
import cliente6 from "../../assets/img/Contactanos/monet.png";

const logos = [cliente1, cliente2, cliente3, cliente4, cliente5, cliente6];

export default function Home() {
    const [index, setIndex] = useState(0);
    const [formData, setFormData] = useState({
        nombre: "",
        telefono: "",
        localidad: "",
    });
    const [status, setStatus] = useState("");

    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prev) => (prev + 3) % logos.length);
        }, 5000);
        return () => clearInterval(interval);
    }, []);

    const visibleLogos = logos.slice(index, index + 3).concat(
        index + 3 > logos.length ? logos.slice(0, (index + 3) % logos.length) : []
    );

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus("Enviando...");

        const mappedData = {
            Nombre: formData.nombre,
            Telefono: formData.telefono,
            Localidad: formData.localidad,
        };
        try {
            const response = await fetch(process.env.REACT_APP_API_LANDING_ENVIAR, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(mappedData),
            });

            if (response.ok) {
                setStatus("✅ Enviado con éxito. Pronto nos contactaremos.");
                setFormData({ nombre: "", telefono: "", localidad: "" });
            } else {
                setStatus("❌ Error al enviar. Intenta nuevamente.");
            }
        } catch {
            setStatus("⚠️ Hubo un problema de conexión.");
        }
    };



    return (
        <div className="landing">
            {/* HEADER */}
            <header className="landing-top">
                <img src={LogoZoco} alt="ZOCO" className="logo-zoco" />
            </header>

            {/* HERO DESKTOP */}
            <section className="hero hero-desktop">
                <div className="hero-left-block">
                    <div className="hero-title-box">
                        <h1 className="hero-title">
                            Recibí pagos en tu negocio<br />
                            con el menor costo y atención<br />
                            humana inmediata.
                        </h1>
                    </div>
                    <div className="hero-pill">Miles de comercios en Tucumán ya lo usan.</div>
                    <div
                        className="hero-ghost"
                        onClick={() => window.open("https://wa.link/oh18kt", "_blank")}
                    >
                        Quiero saber más.
                    </div>
                </div>
                <div className="hero-right">
                    <img src={Terminal} alt="Terminal Zoco" className="hero-img" />
                </div>
            </section>

            {/* HERO MOBILE */}
            <section className="hero hero-mobile">
                <h1 className="hero-title">
                    Recibí pagos en tu negocio<br />
                    con el menor costo y atención<br />
                    humana inmediata.
                </h1>
                <div className="hero-bottom">
                    <div className="hero-left-block">
                        <div className="hero-pill">Miles de comercios en Tucumán ya lo usan.</div>
                        <div
                            className="hero-ghost"
                            onClick={() => window.open("https://wa.link/oh18kt", "_blank")}
                        >
                            Quiero saber más.
                        </div>                    </div>
                    <div className="hero-right">
                        <img src={Terminal} alt="Terminal Zoco" className="hero-img" />
                    </div>
                </div>
            </section>

            {/* BENEFICIOS */}
            <section className="beneficios">
                <div className="beneficio">
                    <img src={menorCosto} alt="El menor costo por operación" className="beneficio-icon" />
                    <span>El menor costo <br /> por operación.</span>
                </div>
                <div className="beneficio">
                    <img src={atencionHumana} alt="Atención humana inmediata" className="beneficio-icon" />
                    <span>Atención humana <br /> inmediata.</span>
                </div>
                <div className="beneficio">
                    <img src={sinGastos} alt="Sin gastos ocultos" className="beneficio-icon" />
                    <span>Sin gastos <br /> ocultos.</span>
                </div>
                <div className="beneficio">
                    <img src={preciso} alt="Preciso, sencillo, seguro" className="beneficio-icon" />
                    <span>Preciso, sencillo, <br /> seguro.</span>
                </div>
            </section>

            {/* CLIENTES + FORMULARIO */}
            <section className="clientes-form">
                {/* Columna izquierda: logos */}
                <div className="clientes">
                    <h2>
                        Algunos de nuestros <br />
                        <span className="verde">clientes</span> en tu provincia.
                    </h2>

                    <div className="clientes-logos">
                        {visibleLogos.map((logo, i) => (
                            <img key={i} src={logo} alt={`Cliente ${i + 1}`} className="cliente-logo" />
                        ))}
                    </div>
                </div>

                {/* Columna derecha: formulario */}
                <div className="formulario">
                    <h2>Solicitá tu terminal.</h2>
                    <form onSubmit={handleSubmit}>
                        <input
                            type="text"
                            name="nombre"
                            placeholder="Nombre"
                            value={formData.nombre}
                            onChange={handleChange}
                            required
                        />
                        <input
                            type="number"
                            name="telefono"
                            placeholder="Teléfono"
                            value={formData.telefono}
                            onChange={handleChange}
                            required
                        />
                        <input
                            type="text"
                            name="localidad"
                            placeholder="Localidad"
                            value={formData.localidad}
                            onChange={handleChange}
                            required
                        />
                        <button type="submit">Enviar</button>
                    </form>
                    {status && <p className="form-status">{status}</p>}
                </div>
            </section>
        </div>
    );
}
